import {
  BENEVA_CODE_SEPARATOR,
  GUARANTEED_INVESTMENT_FUND_NAME_CODE_TO_DV_MAPPING,
  INVESTMENT_ACCOUNT_FUND_NAME_CODE_TO_DV_MAPPING,
} from '@/constants/engine';
import {DomainValueReference} from '@/model/types';

const toDomainValue = (mapping: Record<string, string>, fundNameCode?: string): DomainValueReference | null => {
  if (!fundNameCode) return null;

  // Investment account codes are prefixed by the separator (`RAD` -> `AD`), guaranteed funds are not.
  const benevaId = fundNameCode.startsWith(BENEVA_CODE_SEPARATOR)
    ? fundNameCode.slice(BENEVA_CODE_SEPARATOR.length)
    : fundNameCode;

  if (benevaId in mapping) return {$ref: mapping[benevaId]};
  if (fundNameCode in mapping) return {$ref: mapping[fundNameCode]};

  return null;
};

export const mapInvestmentAccountFundNameCodeToDomainValue = (fundNameCode?: string): DomainValueReference | null =>
  toDomainValue(INVESTMENT_ACCOUNT_FUND_NAME_CODE_TO_DV_MAPPING, fundNameCode);

export const mapGuaranteedInvestmentFundNameCodeToDomainValue = (fundNameCode?: string): DomainValueReference | null =>
  toDomainValue(GUARANTEED_INVESTMENT_FUND_NAME_CODE_TO_DV_MAPPING, fundNameCode);
